import AnimationController from '../../assets/js/controller/animation';
import ResizeController from '../../assets/js/controller/resize';
import ScrollController from '../../assets/js/controller/scroll';

import { bindEvents, clamp, mq } from '../../assets/js/helpers';

const selector = 'badge';

export default class Badge {

	constructor(section) {
		this.el = {
			section,
			svg: section.querySelector('svg'),
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// class variable groups

		this.config = {
			ambientSpeed: 0.4,
			ambientAcceleration: 0.06,
			deltaFactor: 0.02,
			maxSpeed: 1.5,
			minSpeed: 0.01,
			acceleration: 0.12,
			deceleration: 0.05,
			maxDelta: 500
		};

		this.controllers = {
			animation: null,
			resize: null,
			scroll: null
		};

		this.flags = {
			isScrolled: false
		};

		this.states = {
			direction: 0, // scroll direction (-1, 1, or 0)
			ambientDirection: 1, // direction for constant spinning (never 0)
			rotation: 0,
			scrollDelta: 0,
			speed: this.config.ambientSpeed
		};

		// class variable singles

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: this.events._onWindowResize
		});

		if (mq('medium')) {
			this.addScrollListener();
		}
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
		this.removeScrollListener();
	}

	//

	addScrollListener() {
		if (!this.controllers.animation) {
			this.controllers.animation = AnimationController.set({
				update: () => {
					if (this.states.scrollDelta || this.states.speed) {
						return true;
					}
				},
				render: () => {
					const cappedDelta = Math.min(this.config.maxDelta, Math.max(-this.config.maxDelta, this.states.scrollDelta * this.config.deltaFactor));
					let { speed } = this.states;

					if (cappedDelta) {
						speed += (cappedDelta - speed) * 0.06;
					} else {
						speed += (this.config.ambientSpeed * this.states.ambientDirection - speed) * 0.06;
					}

					this.states.speed = speed;

					this.states.rotation += this.states.speed;
					this.el.svg.style.transform = `rotate(${this.states.rotation}deg)`;

					this.flags.isScrolled = false;
				}
			});
		}

		if (!this.controllers.scroll) {
			this.controllers.scroll = ScrollController.set({
				update: (e) => {
					this.states.scrollDelta = clamp(e.delta, -this.config.maxDelta, this.config.maxDelta);
					this.states.direction = e.direction;
					this.flags.isScrolled = true;

					if (this.states.direction) {
						this.states.ambientDirection = this.states.direction;
					}
				},
				render: () => {}
			});
		}
	}

	removeScrollListener() {
		if (this.controllers.animation) {
			AnimationController.clear(this.controllers.animation);
			this.controllers.animation = null;
		}

		if (this.controllers.scroll) {
			ScrollController.clear(this.controllers.scroll);
			this.controllers.scroll = null;
		}
	}

	// listener methods

	_onWindowResize() {
		if (mq('medium')) {
			this.addScrollListener();
		} else {
			this.removeScrollListener();
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
